import { FormControlLabel, Checkbox, FormHelperText, Grid } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IFormValues } from "../../../../types";
import { ReactQueryKey } from "../../../../../../types";

export const FormDiscountType = () => {

    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();
    const discountType = useWatch<IFormValues, 'extraServices.discountType'>({
        name: 'extraServices.discountType'
    });

    const queryClient = useQueryClient();

    const handleChange = useCallback((checked: boolean, value: 'promo' | 'fca') => {
        formContext.setValue(
            'extraServices.discountType',
            checked ? value : null
        );
        formContext.resetField('extraServices.discountCode');
        formContext.resetField('extraServices.fcaBankCardNumber');
        queryClient.resetQueries([ReactQueryKey.Coupon, {
            tenant: formContext.getValues('basicDetails.tenant') as string,
            dealer: formContext.getValues('basicDetails.dealer') as string
        }]);
    }, []);

    return (
        <>
            <Grid container>
                <Grid item md={6} xs={6}>
                    <FormControlLabel
                        label={t('label.promo')}
                        sx={{
                            mt: 2
                        }}
                        control={
                            <Checkbox
                                checked={discountType === 'promo'}
                                onChange={(e, checked) => {
                                    handleChange(checked, 'promo');
                                }}
                                disabled={true}
                            />
                        }
                    />
                    {formContext.control.getFieldState('extraServices.discountType')?.error &&
                        discountType === 'promo' &&
                        <FormHelperText error>
                            {t((formContext.control.getFieldState('extraServices.discountType').error?.message) as string)}
                        </FormHelperText>
                    }
                </Grid>
                <Grid item md={6} xs={6}>
                    <FormControlLabel
                        label={t('label.fcaBank')}
                        sx={{
                            mt: 2
                        }}
                        control={
                            <Checkbox
                                checked={discountType === 'fca'}
                                onChange={(e, checked) => {
                                    handleChange(checked, 'fca');
                                }}
                                disabled={true}
                            />
                        }
                    />
                    {formContext.control.getFieldState('extraServices.discountType')?.error &&
                    discountType === 'fca' &&
                    <FormHelperText error>
                        {t((formContext.control.getFieldState('extraServices.discountType').error?.message) as string)}
                    </FormHelperText>
                    }
                </Grid>
            </Grid>
        </>
    );
};

export default FormDiscountType;
